import Phaser from 'phaser';
import { GAME_CONFIG } from './config/gameConfig';
import BootScene from './scenes/BootScene';
import TitleScene from './scenes/TitleScene';
import PlayScene from './scenes/PlayScene';
import PauseScene from './scenes/PauseScene';
import ResultScene from './scenes/ResultScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_CONFIG.width,
  height: GAME_CONFIG.height,
  parent: 'game-container',
  backgroundColor: GAME_CONFIG.colors.background,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_CONFIG.width,
    height: GAME_CONFIG.height,
    fullscreenTarget: 'game-container',
  },
  dom: {
    createContainer: true,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: GAME_CONFIG.physics.gravity,
      debug: false,
    },
  },
  scene: [BootScene, TitleScene, PlayScene, PauseScene, ResultScene],
};

// リサイズイベントの処理
window.addEventListener('resize', () => {
  if ((window as any).game) {
    (window as any).game.scale.refresh();
  }
});

const game = new Phaser.Game(config);

// グローバルに保存（リサイズ処理用）
(window as any).game = game;

// キャンバスを確実に中央配置
game.scale.on('resize', () => {
  const canvas = game.canvas;
  const container = document.getElementById('game-container');
  if (canvas && container) {
    // キャンバスを中央配置
    canvas.style.position = 'relative';
    canvas.style.margin = '0 auto';
    canvas.style.display = 'block';
  }
});// 初期化時にも実行
setTimeout(() => {
  const canvas = game.canvas;
  const container = document.getElementById('game-container');
  if (canvas && container) {
    canvas.style.position = 'relative';
    canvas.style.margin = '0 auto';
    canvas.style.display = 'block';
  }
}, 100);